import { LANG_FRENCH } from '@/constants';

export const replaceAll = (dataString: string, searchValue: string, replaceValue: string) => {
  if (dataString) {
    const regex = new RegExp(searchValue, 'g');
    return dataString.replace(regex, replaceValue);
  }
  return dataString;
};

export const getTextVariant = (currentLanguage: any, textEn: string, textFr: string): string => {
  return currentLanguage === LANG_FRENCH && textFr ? textFr : textEn;
};
